




























import Vue from 'vue'
import { sprintf } from 'sprintf-js'
import { getText } from '../js/lang'

export default Vue.extend({
  name: 'ticket-menu',
  props: {
    lang: {
      type: String,
      required: true
    }
  },
  methods: {
    l(key: string, ...values: any[]): string {
      return sprintf(getText(this.lang, key), ...values)
    }
  }
})
